import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ConfettiExplosion from 'react-confetti-explosion';

function UserMessage({ numbers, target, hardMode, onGameComplete }) {
  const [done, setDone] = useState(false);

  useEffect(() => {
    setDone(false);
    if (numbers.length && target){
        const d = !canReachTarget(numbers, ['+', '-', '*', '/'], target, hardMode);
        setDone(d);
    }
  }, [target, hardMode, numbers])

  const canReachTarget = (numbers, operations, target, hardMode) => {
    // Try every operation between every pair of numbers
    for (let i = 0; i < numbers.length; i++) {
      for (let j = i + 1; j < numbers.length; j++) {
        for (let op of operations) {
          // Try the operation with both orders of operands
          for (let order = 0; order < 2; order++) {
            let num1 = order === 0 ? numbers[i] : numbers[j];
            let num2 = order === 0 ? numbers[j] : numbers[i];
  
            // Perform the operation
            let result;
            switch (op) {
              case '+':
                result = num1 + num2;
                break;
              case '-':
                result = num1 - num2;
                break;
              case '*':
                result = num1 * num2;
                break;
              case '/':
                if (num2 !== 0) {
                  result = num1 / num2;
                } else {
                  continue;
                }
                break;
            }
  
            // Ensure the result is an integer
            if (!Number.isInteger(result)) {
              continue;
            }
  
            // If the result is the target, and we're either not in hard mode, or we are and there are no other numbers, return true
            if (result === target && (!hardMode || (hardMode && numbers.length === 2))) {
              return true;
            }
  
            // Otherwise, if there are other numbers, try the next operation with the result and the remaining numbers
            if (numbers.length > 2) {
              let remainingNumbers = numbers.filter((_, index) => index !== i && index !== j);
              remainingNumbers.push(result);
              if (canReachTarget(remainingNumbers, operations, target, hardMode)) {
                return true;
              }
            }
          }
        }
      }
    }
  
    // If we've tried every possible combination of operations and none get us to the target, return false
    return false;
  };
  
    
  const explosionParams = {
    force: 0.7,
    duration: 3000,
    particleCount: 225,
    width: 800,
  };

  return (
    <>
    {done ?
        <Typography variant="h5" textAlign="center" alignItems="center" sx={{margin: 'auto', width: '100%'}}>
            Congrats! You reached today's limit!
            <ConfettiExplosion style={{margin: 'auto'}} {...explosionParams} />
        </Typography> 
      : null }
    </>
  );
}

export default UserMessage;
